import { SectionHeader, BfiCustomStore } from '../../common/SharedComponents';
import store, { searchActions } from '@apply/adminStore';
import NoFurtherActionTable from './tables/NoFurtherActionTable';
import RecycleBinTable from './tables/RecycleBinTable';
import IncompleteFileTable from './tables/IncompleteFileTable';
import RollbackModal from '../common/modals/RollbackModal';
import debounce from 'lodash.debounce';
import AppraisalModal from '../appraise/modals/AppraisalModal';
import ApplicationReviewModal from '../submitted/modals/ApplicationReviewModal';
import DeclineOrRecycleModal from '../common/modals/DeclineOrRecycleModal';
import ConvertToLoanModal from '../appraise/modals/ConvertToLoanModal';
import RestoreApplicationModal from './modals/RestoreApplicationModal';
import ApplicationSummaryModal from '../submitted/modals/ApplicationSummaryModal';
import AuditHistoryModal from '../common/modals/AuditHistoryModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';
import { ApplicationFilesModal } from '../common/modals/ApplicationFilesModal';

function DeclinedAppsLanding() {
    const searchState = useSelector((state) => state.searchState);
    const { dispatch } = store;
    const debouncedSearch = debounce(dispatch, 500);

    const incompleteFileGridStore = new BfiCustomStore();
    const noFurtherActionGridStore = new BfiCustomStore();
    const recycleBinGridStore = new BfiCustomStore();

    const _onSearchChange = (event) => {
        debouncedSearch(
            searchActions.setSearchText({
                searchText: {
                    ...searchState.searchText,
                    application: event.target.value,
                },
            })
        );
    };

    return (
        <>
            <SectionHeader title='Lost & Declined Applications' />
            <div
                className='main-content'
                style={{ padding: 0, backgroundColor: '#f4f4f4' }}
            >
                <div className='input-has-icon main-search'>
                    <input
                        type='search'
                        placeholder='Search on BFI Number, City, State, Borrower or User...'
                        defaultValue={searchState?.searchText?.application}
                        onChange={_onSearchChange}
                    />
                    <FontAwesomeIcon
                        icon={faSearch}
                        aria-hidden='true'
                        className='icon'
                    />
                </div>
                <div
                    className='scrollable-content'
                    style={{ padding: '1rem' }}
                >
                    <div
                        className='applications accordion'
                        data-accordion=''
                        data-allow-all-closed='true'
                        data-multi-expand='true'
                    >
                        <IncompleteFileTable gridStore={incompleteFileGridStore} />
                        <NoFurtherActionTable gridStore={noFurtherActionGridStore} />
                        <RecycleBinTable gridStore={recycleBinGridStore} />
                    </div>
                </div>
            </div>
            <ApplicationReviewModal />
            <ApplicationSummaryModal />
            <AppraisalModal />
            <RollbackModal />
            <DeclineOrRecycleModal />
            <ConvertToLoanModal />
            <RestoreApplicationModal />
            <AuditHistoryModal />
            <ApplicationFilesModal />
        </>
    );
}

export default DeclinedAppsLanding;
